import React, { FC, Fragment, useState, useEffect, useContext } from "react";
import { Tab } from "@headlessui/react";
import fps from "images/fps.png";
import payme from "images/payme_logo.png";
import paymeHsbc from "images/paymeHSBC.png";
import aliPay from "images/aliPay.png";
import weChat from "images/weChat.png";
import master from "images/masterLogo.png";
import visa from "images/visaLogo.png";
import { getPureArray } from "utils/util";

export interface ComponentProps {
    className?: string;
    // onCartSkuListChange?: () => void;
};

const PaymentMethodTab: FC<ComponentProps> = (props) => {
    const { className } = props;

    return (
        <>
            <Tab.List className="flex">
                <Tab as={Fragment}>
                    {({ selected }) => (
                        <div className="paymentMethodWrapper">
                            <div className="paymentMethod grid w-full grid-cols-3 gap-3 sm:grid-cols-4 sm:gap-4 lg:grid-cols-3 xl:grid-cols-5">
                                <img className="border border-neutral-100" src={fps} alt="" />
                                {/* <img className="border border-neutral-100" src={payme} alt="" /> */}
                                <img className="border border-neutral-100" src={master} alt="" />
                                <img className="border border-neutral-100" src={visa} alt="" />
                                <img className="border border-neutral-100" src={weChat} alt="" />
                                <img className="border border-neutral-100" src={aliPay} alt="" />
                            </div>
                        </div>
                    )}
                </Tab>
            </Tab.List>
        </>
    );
};

export default PaymentMethodTab;